import React from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue } from 'redux-form';
import { formatarReal } from '../../util/numberUtil';
import DetalheEncomenda from './DetalheEncomenda';
import alterarExibicaoEncomenda from '../../actions/encomenda/alterarExibicaoEncomenda';
import selecionarEncomenda from '../../actions/encomenda/selecionarEncomenda';

export class LinhaEncomendaEntrega extends React.Component {

  getEncomendaBadgeClass(situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s.includes('APROVADO') || s.includes('ENTREGUE') || s.includes('CONFIRMADO')) return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('RECUSADO')) return 'vx-gp-badge--cancelado';
    if (s.includes('PENDENTE') || s.includes('ABERTO') || s.includes('AGUARDANDO') || s.includes('TR')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  // "Recebida"/"Em rota" ainda não chegaram ao destinatário -- exibidos como
  // "Pendente entrega", como pedido no texto original da demanda
  descricaoStatusEntrega(situacao) {
    const s = (situacao || '').toLowerCase();
    if (s === 'recebida' || s === 'em rota') return 'Pendente entrega';
    return situacao;
  }

  render() {
    const encomenda = this.props.encomenda;
    const isOpen = encomenda.exibirDetalhe;
    const statusEntrega = this.descricaoStatusEntrega(encomenda.descricaoSituacaoEntrega);
    return (
      <div className={`vx-gp-row${isOpen ? ' vx-gp-row--open' : ''}`}>
        <div className="vx-gp-row-main vx-gp-row-main--registrar-entrega">
          <div className="vx-gp-toggle" onClick={() => this.props.alterarExibicaoEncomenda(encomenda)}>
            <span className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Nº Pedido</span>
            <span className="vx-gp-field-value">{encomenda.idPedido}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Vendedor</span>
            <span className="vx-gp-field-value">{encomenda.nomeVendedor}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Descrição</span>
            <span className="vx-gp-field-value">{encomenda.descricaoProduto}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Remetente</span>
            <span className="vx-gp-field-value">{encomenda.remetente.nome}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data Emissão</span>
            <span className="vx-gp-field-value">{encomenda.dataCriacao}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data Entrega</span>
            <span className="vx-gp-field-value">{encomenda.dataEntrega || '—'}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Status de Entrega</span>
            <span className={`vx-gp-badge ${this.getEncomendaBadgeClass(statusEntrega)}`}>
              {statusEntrega}
            </span>
          </div>
          <div className="vx-gp-field vx-gp-field--price">
            <span className="vx-gp-field-label">Valor</span>
            <span className="vx-gp-field-value">{formatarReal(encomenda.valorTotal)}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Ações</span>
            {encomenda.sePodeInformarEntrega !== false
              ? <button type="button"
                  className="vx-bag-btn vx-bag-btn--receipt"
                  style={{ width: 'auto' }}
                  data-toggle="modal"
                  data-target="#modalInformarEntregaEncomenda"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.changeFieldValue('formularioInformarEntregaEncomenda', 'observacao', encomenda.observacaoEntrega);
                    this.props.preencherModalInformarEntregaEncomenda(encomenda.imagensInformarEntrega);
                    this.props.selecionarEncomenda(encomenda);
                  }}>
                  Informar entrega
                </button>
              // depois de finalizada, o botão de ação some e vira um menu "⋮"
              // com um item informativo (quem entregou e quando)
              : <div className="dropdown" onClick={e => e.stopPropagation()}>
                  <button className="vx-actions-trigger" type="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="material-icons">more_vert</span>
                  </button>
                  <div className="dropdown-menu vx-gp-dropdown-menu">
                    <span className="vx-gp-dropdown-item" style={{ cursor: 'default' }}>
                      <span className="material-icons" style={{ color: '#2e7d32' }}>history</span>
                      Entregue por {encomenda.nomeUsuarioEntrega} em {encomenda.dataEntrega}
                    </span>
                  </div>
                </div>}
          </div>
        </div>
        <div style={{ padding: '2px 14px 8px', display: 'flex', gap: 16, fontSize: 12, color: '#888' }}>
          <span><strong style={{ color: '#555' }}>Origem:</strong> {encomenda.cidadeOrigem}</span>
          <span><strong style={{ color: '#555' }}>Destino:</strong> {encomenda.cidadeDestino}</span>
        </div>
        <DetalheEncomenda encomenda={encomenda} />
      </div>
    )
  }
}

export default connect(null, {
  selecionarEncomenda,
  changeFieldValue,
  alterarExibicaoEncomenda
})(LinhaEncomendaEntrega)
